/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import { BackgroundPanel, Panel } from "vr-react-components";
import JobRoomWorkstationTooltip from "../../../widgets/JobRoomWorkstationTooltip";
import BarPanelWidget from "../../../widgets/BarWidget/BarPanelWidget";

const LeftPanelVR = React.memo(({ width, height }) => {
    const currentRoom = useSelector((state) => state.room.history[0].ID);
    const selectedWorkstation = useSelector((state) => state.workstationroom.selectedWorkstation);
    const canModify = useSelector((state) => state.private.device.canModify);
    
    const innerWidth = (width / 2) * 0.9;
    const innerHeight = height * 0.9;
    const padding = innerWidth / 50;

    const textSize = 45 / innerWidth;

    return (
        <BackgroundPanel
            width={width / 2}
            height={height}
            position={`${-width / 4} 0 0`}
            rotation="0 30 0"
        >
            <JobRoomWorkstationTooltip
                backgroundColor={"#262626"}
                width={innerWidth - padding}
                height={innerHeight * 0.5 - padding}
                position={`0 ${innerHeight / 2 - (innerHeight * 0.5 - padding) / 2
                    } 0.001`}
                textSizeDecimal={textSize}
                element={{
                    name: selectedWorkstation.name,
                    type: selectedWorkstation?.type,
                    limit: selectedWorkstation.limit,
                    runningJobs: selectedWorkstation.workstationJobsDetails
                        ? selectedWorkstation.workstationJobsDetails.running
                        : 0,
                    status: selectedWorkstation.status,
                    jobReady: selectedWorkstation.workstationJobsDetails
                        ? selectedWorkstation.workstationJobsDetails.ready
                        : 0,
                }}
            />
            <Panel
                position={`0 ${-height / 2 + innerHeight / 4 + height * 0.05} 0.001`}
                aframeClasses={canModify ? "collidable" : ""}
                panel
                width={innerWidth - padding}
                height={innerHeight / 2 - padding}
                backgroundColor="#262626"
                resize
                title="Job Status (grouped data)"
                textSizeDecimal={textSize}
            >
                <BarPanelWidget
                    grouped
                    stateName={"barPanelData"}
                    currentRoom={currentRoom}
                    aspectRatio={1.5}
                />
            </Panel>
        </BackgroundPanel>
    );
});

export default LeftPanelVR